import React, { useState } from 'react';
import { Calendar, MapPin, Music, X } from 'lucide-react';

const Events = () => {
  const [showFlyers, setShowFlyers] = useState(false);

  const eventFlyers = [
    {
      id: 3,
      title: "Jump Up in the Jungle 3 - Millz",
      date: "4th July 2026",
      image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/r41wy7w7_161706.jpg"
    },
    {
      id: 1,
      title: "Jump Up in the Jungle - Kenny Ken",
      date: "6th September 2025",
      image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/f5mdfm00_139815.jpg"
    },
    {
      id: 2,
      title: "Jump Up in the Jungle - Millz & Jayline",
      date: "29th November 2025",
      image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/9eny2mmh_139813.jpg"
    }
  ];

  return (
    <section id="events" className="relative py-16 bg-gradient-to-b from-black via-zinc-900 to-black">
      {/* Background effect */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-green-900/20 via-black to-black opacity-50"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-zinc-900/70 backdrop-blur-sm border-2 border-green-500/30 rounded-2xl p-8 shadow-[0_0_60px_rgba(0,255,136,0.2)]">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="inline-block bg-green-500/10 border border-green-500/50 rounded-lg px-6 py-2 mb-4">
              <p className="text-green-400 font-bold text-sm tracking-wider">NUMERO UNO PRESENTS</p>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
              JUMP UP IN THE
              <span className="block text-green-400 mt-2 drop-shadow-[0_0_20px_rgba(0,255,136,0.8)]">
                JUNGLE
              </span>
            </h2>
            <div className="w-24 h-1 bg-green-500 mx-auto mt-4 shadow-[0_0_10px_rgba(0,255,136,0.8)]"></div>
          </div>

          {/* Description */}
          <div className="text-center max-w-2xl mx-auto mb-8">
            <p className="text-gray-300 text-lg leading-relaxed mb-4">
              Numero Uno Sounds doesn't just release music — we bring the underground to life.
            </p>
            <p className="text-gray-400 mb-6">
              <strong className="text-white">Jump Up in the Jungle</strong> is our signature event series, showcasing the heaviest Jump-Up and Jungle sounds alongside established and emerging talent from the scene.
            </p>
          </div>

          {/* Past Event - Jump Up in the Jungle 3 */}
          <div className="bg-gradient-to-br from-zinc-900/20 to-black/50 border-2 border-zinc-500/30 rounded-2xl p-8 mb-8">
            <div className="inline-block bg-zinc-600 text-white font-bold px-4 py-1 rounded-full text-sm mb-4">
              PAST EVENT
            </div>
            <h3 className="text-3xl font-bold text-gray-300 mb-4">
              Jump Up in the Jungle 3
            </h3>
            
            <div className="grid md:grid-cols-2 gap-6">
              {/* Event Details */}
              <div>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center gap-3 text-gray-400">
                    <Calendar className="w-5 h-5 text-gray-500" />
                    <span>Saturday 4th July 2026 | 8PM - 3AM</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-400">
                    <MapPin className="w-5 h-5 text-gray-500" />
                    <span>Lemz Studioz - Readmans Industrial Estate, East Tilbury</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-400">
                    <Music className="w-5 h-5 text-gray-500" />
                    <span className="italic">This event has been completed</span>
                  </div>
                </div>

                <div className="bg-black/40 border border-zinc-500/20 rounded-lg p-4 mb-4 opacity-70">
                  <h4 className="text-gray-400 font-bold mb-3">HEADLINER</h4>
                  <p className="text-2xl font-bold text-gray-300">MILLZ</p>
                </div>

                <div className="bg-black/40 border border-zinc-500/20 rounded-lg p-4 opacity-70">
                  <h4 className="text-gray-400 font-bold mb-3">LINEUP</h4>
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <span className="text-gray-300">• Numero Uno Crew</span>
                    <span className="text-gray-300">• Lost in Bass</span>
                    <span className="text-gray-300">• Certified Dan</span>
                    <span className="text-gray-300">• Robbie Dee - The Original Detonator</span>
                    <span className="text-gray-300">• Strictly Drumgle</span>
                    <span className="text-gray-300">• Rewrite</span>
                    <span className="text-gray-300 col-span-2">• MCs: Robbie Dee, Immnce, Blair The Raver</span>
                  </div>
                </div>
              </div>

              {/* Event Poster */}
              <div>
                <img 
                  src="https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/r41wy7w7_161706.jpg" 
                  alt="Jump Up in the Jungle 3"
                  className="w-full rounded-xl border-2 border-zinc-500/20 shadow-lg opacity-80"
                />
              </div>
            </div>
          </div>

          {/* Event Info Grid */}
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <button
              onClick={() => setShowFlyers(true)}
              className="bg-black/40 border border-green-500/20 rounded-lg p-6 text-center hover:bg-green-500/10 hover:border-green-500/50 transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              <Calendar className="text-green-400 mx-auto mb-3 group-hover:scale-110 transition-transform duration-300" size={32} />
              <h3 className="text-white font-bold mb-2 group-hover:text-green-400 transition-colors duration-300">Series Events</h3>
              <p className="text-gray-400 text-sm group-hover:text-gray-300 transition-colors duration-300">3 events completed, more to come</p>
              <p className="text-green-400 text-xs mt-2 font-semibold">Click to view flyers</p>
            </button>
            <div className="bg-black/40 border border-green-500/20 rounded-lg p-6 text-center">
              <Music className="text-green-400 mx-auto mb-3" size={32} />
              <h3 className="text-white font-bold mb-2">Heavy Lineup</h3>
              <p className="text-gray-400 text-sm">Featuring scene legends & rising stars</p>
            </div>
            <div className="bg-black/40 border border-green-500/20 rounded-lg p-6 text-center">
              <MapPin className="text-green-400 mx-auto mb-3" size={32} />
              <h3 className="text-white font-bold mb-2">Essex Based</h3>
              <p className="text-gray-400 text-sm">Underground venues, proper sound systems</p>
            </div>
          </div>

          {/* Past Events Highlight */}
          <div className="bg-gradient-to-br from-green-500/5 to-purple-500/5 border border-green-500/20 rounded-xl p-6">
            <p className="text-green-400 font-semibold mb-3 text-center">Past Events Featured:</p>
            <div className="flex flex-wrap justify-center gap-3 text-sm items-center">
              <span className="bg-black/50 border border-green-500/30 px-4 py-2 rounded-full text-gray-300">Kenny Ken</span>
              <span className="bg-black/50 border border-green-500/30 px-4 py-2 rounded-full text-gray-300">Millz</span>
              <span className="bg-black/50 border border-green-500/30 px-4 py-2 rounded-full text-gray-300">Jayline</span>
              <span className="bg-black/50 border border-green-500/30 px-4 py-2 rounded-full text-gray-300">Lost in Bass</span>
              <span className="bg-black/50 border border-green-500/30 px-4 py-2 rounded-full text-gray-300">Certified Dan</span>
              <span className="bg-black/50 border border-green-500/30 px-4 py-2 rounded-full text-gray-300 text-center">
                <div className="font-bold">Robbie Dee</div>
                <div className="text-xs">The Original Detonator</div>
              </span>
            </div>
          </div>

          {/* Status */}
          <div className="text-center mt-8">
            <p className="text-gray-400 italic mb-4">
              Currently focusing on building label presence and artist bookings — events will return stronger than ever.
            </p>
            <p className="text-white font-semibold">
              Stay tuned for the next <span className="text-green-400">Jump Up in the Jungle</span> 🔥
            </p>
          </div>
        </div>
      </div>

      {/* Flyers Modal */}
      {showFlyers && (
        <div 
          className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto"
          onClick={() => setShowFlyers(false)}
        >
          <div 
            className="bg-gradient-to-b from-zinc-900 to-zinc-950 border-2 border-green-500/40 rounded-2xl p-6 max-w-6xl w-full shadow-[0_0_80px_rgba(0,255,136,0.5)] relative animate-fade-in my-8"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button - positioned much lower for mobile status bar */}
            <button
              onClick={() => setShowFlyers(false)}
              className="absolute top-20 right-4 sm:top-4 p-3 bg-zinc-800/90 hover:bg-zinc-700 rounded-full transition-all duration-200 hover:scale-110 group shadow-lg z-50 border-2 border-green-500/50"
              aria-label="Close"
            >
              <X size={26} className="text-white group-hover:text-green-400" />
            </button>

            {/* Modal Header */}
            <div className="text-center mb-8">
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
                JUMP UP IN THE
                <span className="block text-green-400 mt-1 drop-shadow-[0_0_20px_rgba(0,255,136,0.8)]">
                  JUNGLE
                </span>
              </h2>
              <p className="text-gray-400 mt-3">Past Event Flyers</p>
            </div>

            {/* Flyers Grid */}
            <div className="grid md:grid-cols-2 gap-6">
              {eventFlyers.map((flyer) => (
                <div 
                  key={flyer.id}
                  className="group relative bg-zinc-900/50 border border-green-500/20 rounded-xl overflow-hidden hover:border-green-500/60 transition-all duration-300 hover:shadow-[0_0_40px_rgba(0,255,136,0.3)]"
                >
                  <img 
                    src={flyer.image} 
                    alt={flyer.title}
                    className="w-full h-auto object-cover"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/80 to-transparent p-4">
                    <p className="text-green-400 font-bold text-lg">{flyer.date}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer Note */}
            <div className="text-center mt-6">
              <p className="text-gray-400 text-sm italic">
                More events coming soon! Stay tuned 🔥
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Events;
